import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { ShieldAlert } from "lucide-react";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/admin/login", { email, password });
      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));
      toast.success("Admin authenticated");
      navigate("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center px-6 grain bg-[var(--paper)]">
      <div className="w-full max-w-md relative z-10">
        <Link to="/" className="font-display text-lg font-medium tracking-tight flex items-center gap-2 mb-10">
          <span className="w-6 h-6 grid place-items-center bg-black text-white font-black">Æ</span>
          Aegis Realtor
        </Link>
        <div className="flex items-center gap-2 text-[10px] tracking-[0.35em] uppercase text-muted-foreground mb-3">
          <ShieldAlert className="w-3.5 h-3.5" /> Restricted area
        </div>
        <h1 className="font-display text-4xl font-black tracking-tighter mb-2">Admin console</h1>
        <p className="text-sm text-muted-foreground mb-8">Platform owner access only.</p>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-[10px] tracking-[0.25em] uppercase font-bold text-muted-foreground">Email</label>
            <input
              data-testid="admin-email"
              type="email" required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full mt-2 px-4 py-3 bg-white hairline focus:border-black outline-none"
            />
          </div>
          <div>
            <label className="text-[10px] tracking-[0.25em] uppercase font-bold text-muted-foreground">Password</label>
            <input
              data-testid="admin-password"
              type="password" required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full mt-2 px-4 py-3 bg-white hairline focus:border-black outline-none"
            />
          </div>
          <button
            data-testid="admin-submit"
            disabled={busy}
            className="w-full py-3 bg-black text-white font-bold tracking-wide disabled:opacity-40"
          >
            {busy ? "Signing in…" : "Enter admin console"}
          </button>
        </form>
      </div>
    </div>
  );
}
